import photo1 from "../assets/info/chrysler-300c/300cside.jpg";
import photo2 from "../assets/info/ford-ranger/ranger2wdside.jpg";
import photo3 from "../assets/info/ford-ranger/ranger4wdside.jpg";
import photo4 from "../assets/info/ford-mustang/mustang-cc.jpg";
import photo5 from "../assets/info/ford-mustang/mustang-coupe.jpg";
import photo6 from "../assets/info/ford-mustang/mustang-convertible.jpg";
import photo7 from "../assets/info/santa-fe/small1.jpg";
import photo8 from "../assets/info/santa-fe/small2.jpg";
import photo9 from "../assets/info/santa-fe/small3.jpg";
import photo10 from "../assets/info/isuzu-d-max/dmaxside.jpg";
import photo11 from "../assets/info/kia-sorento/kia-sorento-small.jpg";
import photo12 from "../assets/info/mazda-mx-5/na-mx5-small-v3.jpg";
import photo13 from "../assets/info/mazda-mx-5/nd-mx5-small-v2.jpg";
import photo14 from "../assets/info/mitsubishi-l200/mitsl200-2wd.jpg";
import photo15 from "../assets/info/mitsubishi-l200/mitsl200-4wd.jpg";
import photo16 from "../assets/info/mitsubishi-pajero/shogunlwb.jpg";
import photo17 from "../assets/info/mitsubishi-pajero/shogunswb.jpg";
import photo18 from "../assets/info/mitsubishi-shogun-sport/shogun-sport.jpg";
import photo19 from "../assets/info/nissan-navara/nissannavara2.jpg";
import photo20 from "../assets/info/nissan-navara/nissannavara1.jpg";
import photo21 from "../assets/info/nissan-pathfinder/pathfinder-2018.jpg";
import photo22 from "../assets/info/nissan-patrol/patrolold.jpg";
import photo23 from "../assets/info/nissan-x-trail/nissanxtrail2001.jpg";
import photo24 from "../assets/info/nissan-x-trail/nissanxtrail2009.jpg";
import photo25 from "../assets/info/nissan-x-trail/nissanxtrail2018.jpg";
import photo26 from "../assets/info/subaru-forester/subaru-forester-1.jpg";
import photo27 from "../assets/info/subaru-forester/subaru-forester-2.jpg";
import photo28 from "../assets/info/subaru-impreza/impreza-parts-classic.jpg";
import photo29 from "../assets/info/subaru-impreza/impreza-parts-bug.jpg";
import photo30 from "../assets/info/subaru-impreza/impreza-parts-blob.jpg";
import photo31 from "../assets/info/subaru-impreza/impreza-parts-shark.jpg";
import photo32 from "../assets/info/subaru-impreza/impreza-parts-gvsedan.jpg";
import photo33 from "../assets/info/subaru-impreza/subaru-impreza-gj.jpg";
import photo34 from "../assets/info/subaru-brz/gt86-side.jpg";
import photo35 from "../assets/info/toyota-hilux-4wd/hilux_3.jpg";
import photo36 from "../assets/info/toyota-hilux-4wd/hilux_6.jpg";
import photo37 from "../assets/info/toyota-hilux-4wd/mk8-hilux-small.jpg";
import photo38 from "../assets/info/toyota-landcruiser/landcruiser-1.png";
import photo39 from "../assets/info/toyota-landcruiser/landcruiser-2.jpg";
import photo40 from "../assets/info/toyota-landcruiser/landcruiser-3.png";
import photo41 from "../assets/info/toyota-landcruiser/landcruiser-4.png";
import photo42 from "../assets/info/toyota-landcruiser/landcruiser-5.png";
import photo43 from "../assets/info/toyota-landcruiser/landcruiser-6.png";
import photo44 from "../assets/info/toyota-landcruiser/landcruiser-7.png";
import photo45 from "../assets/info/toyota-landcruiser/landcruiser-8.png";
import photo46 from "../assets/info/toyota-landcruiser/landcruiser-9.png";
import photo47 from "../assets/info/toyota-landcruiser/landcruiser-10.png";
import photo48 from "../assets/info/vw-amarok/amarokside.jpg";
import photo49 from "../assets/info/vw-transporter/vw-t30.jpg";
import photo50 from "../assets/info/vw-transporter/vw-t40.jpg";
import photo51 from "../assets/info/vw-transporter/vw-t50.jpg";
import photo52 from "../assets/info/vw-golf/golfoldside.jpg";
import photo53 from "../assets/info/vw-golf/golfside.jpg";

export const partsCatalogue = [
  {
    make: "Chrysler",
    model: "300C",
    links: [
      {
        title: "2005-On",
        photo: photo1,
        links: [
          {
            link:
              "parts?make=Chrysler&model=300&peryear=2005&variant=3.0lt+6cyl+TD",
            name: "2005-2012 3.0lt 6cyl TD",
          },
          {
            link:
              "parts?make=Chrysler&model=300&peryear=2005&variant=3.5lt+6cyl+ULP",
            name: "2005-2012 3.5lt 6cyl ULP",
          },
          {
            link:
              "parts?make=Chrysler&model=300&peryear=2005&variant=5.7lt+8cyl+ULP",
            name: "2005-2012 5.7lt 8cyl ULP",
          },
          {
            link: "parts?make=Chrysler&model=300&peryear=2012&variant=",
            name: "2012-on",
          },
        ],
      },
    ],
  },
  {
    make: "Ford",
    model: "Ranger",
    links: [
      {
        title: "2WD Hi-Ride & Low-Ride",
        photo: photo2,
        links: [
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2018&variant=PX+MK3+%28MY2019%29%2C+2WD+Hi-Ride",
            name: "2WD Hi-Ride 2018/7 on PX MkIII (MY19)",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2015&variant=PX+MK2%2C+2WD+Hi-Ride",
            name: "2WD Hi-Ride 2015-6/2018 PX MkII",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2011&variant=PX%2C+2WD+Hi-Ride",
            name: "2WD Hi-Ride 2011-2015 PX MKI",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2009&variant=PK%2C+2WD+Hi-Ride",
            name: "2WD Hi-Ride 2009-2011 PK",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2006&variant=PJ%2C+2WD+Lo-Ride",
            name: "2WD Hi-Ride 2006-2009 PJ",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2015&variant=PX+MK2%2C+2WD+Lo-Ride",
            name: "2WD Lo-Ride 2015-6/2018 PX MkII (MY19)",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2011&variant=PX%2C+2WD+Lo-Ride",
            name: "2WD Lo-Ride 2011-2015 PX",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2009&variant=PK%2C+2WD+Lo-Ride",
            name: "2WD Lo-Ride 2009-2011 PK",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2006&variant=PJ%2C+2WD+Lo-Ride",
            name: "2WD Lo-Ride 2006-2009 PJ",
          },
        ],
      },
      {
        title: "4WD",
        photo: photo3,
        links: [
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2023&variant=P703+3.0+V6",
            name: "2023-Onwards 3.0 V6",
          },
          {
            link: "parts?make=Ford&model=Ranger&peryear=2023&variant=P703+2.0",
            name: "2023-Onwards 2.0",
          },
          {
            link:
              "parts?make=Ford&model=Raptor&peryear=2019&variant=4WD%2C+2.0+Model+ONLY",
            name: "2019 on Raptor",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2019&variant=PX+MK3%2C+4WD+3.2+Wildtrack+Model+ONLY",
            name: "07/2019 on PX MkIII 3.2 Wildtrack",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2019&variant=PX+MK3%2C+4WD+2.0+Model+ONLY",
            name: "07/2019 on PX MkIII 2.0",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2019&variant=PX+MK3%2C+4WD+2.2L+and+3.2L+ONLY",
            name: "07/2018 to 07/2019 PX MkIII 2.2 & 3.2",
          },
          {
            link:
              "parts?make=Ford&model=Ranger&peryear=2015&variant=PX+MK2%2C+4WD",
            name: "2015-6/2018 PX MkII",
          },
          {
            link: "parts?make=Ford&model=Ranger&peryear=2009&variant=PK%2C+4WD",
            name: "2009-2011 PK",
          },
          {
            link: "parts?make=Ford&model=Ranger&peryear=2006&variant=PJ%2C+4WD",
            name: "2006-2009 PJ",
          },
        ],
      },
    ],
  },
  {
    make: "Ford",
    model: "Mustang",
    links: [
      {
        title: "Coupe & Convertible",
        photo: photo4,
        links: [
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=1964&variant=Coupe+%26+Convertible",
            name: "1964-1970",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=1970&variant=Coupe+%26+Convertible",
            name: "1970-1973",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=1992&variant=Convertible",
            name: "1992-On",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2001&variant=Cobra%2C+Coupe+%26+Convertible",
            name: "2001-On Cobra",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2004&variant=Coupe+%26+Convertible",
            name: "2004-2014",
          },
        ],
      },
      {
        title: "Coupe",
        photo: photo5,
        links: [
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2015&variant=FM+Coupe%2C+2.3lt+4cyl+TULP",
            name: "2015-2018 FM 2.3lt 4cyl TULP",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2015&variant=FM+Coupe%2C+5.0lt+8cyl+ULP",
            name: "2015-2018 FM 5.0lt 8cyl ULP",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2018&variant=FN+Coupe%2C+2.3lt+4cyl+TULP",
            name: "2018-2023 FN 2.3lt 4cyl TULP",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2018&variant=FM+Coupe%2C+5.0lt+8cyl+ULP",
            name: "2018-2023 FN 5.0lt 8cyl ULP",
          },
        ],
      },
      {
        title: "Convertible",
        photo: photo6,
        links: [
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2015&variant=FM+Convertible%2C+2.3lt+4cyl+TULP",
            name: "2015-2018 FM 2.3lt 4cyl TULP",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2015&variant=FM+Convertible%2C+5.0lt+8cyl+ULP",
            name: "2015-2018 FM 5.0lt 8cyl ULP",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2018&variant=FN+Convertible%2C+2.3lt+4cyl+TULP",
            name: "2018-2023 FN 2.3lt 4cyl TULP",
          },
          {
            link:
              "parts?make=Ford&model=Mustang&peryear=2018&variant=FN+Convertible%2C+5.0lt+8cyl+ULP",
            name: "2018-2023 FN 5.0lt 8cyl ULP",
          },
        ],
      },
    ],
  },
  {
    make: "Hyundai",
    model: "Santa Fe",
    links: [
      {
        title: "SM",
        photo: photo7,
        links: [
          {
            link: "parts?make=Hyundai&model=Santa+Fe&peryear=2000&variant=SM",
            name: "2000-2006 Wagon",
          },
        ],
      },
      {
        title: "CM",
        photo: photo8,
        links: [
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2006&variant=CM%2C+2.2lt+4cyl+TD",
            name: "2006-10/2009 2.2lt 4cyl TD",
          },
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2006&variant=CM%2C+2.7lt+6cyl+ULP",
            name: "2006-10/2009 2.7lt 6cyl ULP",
          },
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2006&variant=CM%2C+3.3lt+6cyl+ULP",
            name: "2006-10/2009 3.3lt 6cyl ULP",
          },
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2009&variant=CM%2C+2.2lt+4cyl+TD",
            name: "2009/11-2012 2.2lt 4cyl TD",
          },
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2009&variant=CM%2C+3.5lt+6cyl+ULP",
            name: "2009/11-2012 3.5lt 6cyl ULP",
          },
        ],
      },
      {
        title: "DM",
        photo: photo9,
        links: [
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2012&variant=DM+AWD%2C+2.2lt+4cyl+TD",
            name: "2012-on AWD 2.2lt 4cyl TD",
          },
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2012&variant=DM+AWD%2C+2.4lt+4cyl+ULP",
            name: "2012-on AWD 2.4lt 4cyl ULP",
          },
          {
            link:
              "parts?make=Hyundai&model=Santa+Fe&peryear=2012&variant=DM+AWD%2C+3.3lt+6cyl+ULP",
            name: "2012-on FWD 3.3lt 6cyl ULP",
          },
        ],
      },
    ],
  },
  {
    make: "Isuzu",
    model: "D-Max",
    links: [
      {
        title: "D-Max",
        photo: photo10,
        links: [
          {
            link:
              "parts?make=Isuzu&model=D+Max&peryear=2008&variant=4WD+%2C+3.0lt+4cyl+TD",
            name: "2008-2012 4WD 3.0lt 4cyl TD",
          },
          {
            link:
              "parts?make=Isuzu&model=D+Max&peryear=2012&variant=4WD%2C+2.5TD",
            name: "2012-17 4WD 2.5TD",
          },
          {
            link:
              "parts?make=Isuzu&model=D+Max&peryear=2017&variant=4WD+%28UK+%26+EU+Markets%29%2C+1.9lt+4cyl+TD",
            name: "2017-2020 4WD (UK & EU Markets) 1.9lt 4cyl",
          },
          {
            link:
              "parts?make=Isuzu&model=D+Max&peryear=2021&variant=4WD+%28UK+%26+EU+Markets%29%2C+1.9lt+4cyl+TD",
            name: "2021-on 4WD (UK & EU Markets)",
          },
        ],
      },
    ],
  },
  {
    make: "Kia",
    model: "Sorento",
    links: [
      {
        title: "",
        photo: photo11,
        links: [
          {
            link:
              "parts?make=Kia&model=Sorento&peryear=2015&variant=UM+AWD%2C+2.2lt+4cyl+TD",
            name: "UM AWD 2015 +",
          },
          {
            link: "parts?make=Kia&model=Sorento&peryear=2012&variant=XM+Gen+2",
            name: "XM Gen II 2012 / 8 - 2015",
          },
          {
            link: "parts?make=Kia&model=Sorento&peryear=2009&variant=XM+Gen+1",
            name: "XM Gen I 2009 - 7 / 2012",
          },
          {
            link: "parts?make=Kia&model=Sorento&peryear=2002&variant=JC",
            name: "JC 2002 - 2009",
          },
        ],
      },
    ],
  },
  {
    make: "Mercedes",
    model: "X-Class",
    links: [
      {
        title: "X-Class Pick-Up",
        photo: "",
        links: [
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2018&variant=X350d-3.0+V6+TD%2C+4+Door+Pick-up",
            name: "X350d 3.0L V6 TD Pick-Up",
          },
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X250d-2.3lt+4cyl+TTD%2C+4+Door+Pick-up",
            name: "X250d 2.3L TTD Pick-Up",
          },
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X250d-2.3lt+4cyl+TD%2C+4+Door+Pick-up",
            name: "X250d 2.3L TD Pick-Up",
          },
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X220d-2.3lt+4cyl+TTD%2C+4+Door+pick-up",
            name: "X220d 2.3L TTD Pick-Up",
          },
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X220d-2.3lt+4cyl+TD%2C+4+Door+pick-up",
            name: "X220d 2.3L TD Pick-Up",
          },
        ],
      },
      {
        title: "X-Class Cab Chassis",
        photo: "",
        links: [
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X250d-2.3lt+4cyl+TTD%2C+4+Door+Cab+Chassis",
            name: "X250d 2.3L TTD Cab Chassis",
          },
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X250d-2.3lt+4cyl+TD%2C+4+Door+Cab+Chassis",
            name: "X250d 2.3L TD Cab Chassis",
          },
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X220d+-2.3lt+4cyl+TTD%2C+4+Door+Cab+Chassis",
            name: "X220d 2.3L TTD Cab Chassis",
          },
          {
            link:
              "parts?make=Mercedes-Benz&model=X-Class&peryear=2017&variant=X220d+-2.3lt+4cyl+TD%2C+4+Door+Cab+Chassis",
            name: "X220d 2.3L TD Cab Chassis",
          },
        ],
      },
    ],
  },
  {
    make: "Mazda",
    model: "MX5",
    links: [
      {
        title: "NA & NB",
        photo: photo12,
        links: [
          {
            link: "parts?make=Mazda&model=MX5&peryear=1989&variant=NA6+%26+NA8",
            name: "1989-1997 NA6 & NA8",
          },
          {
            link:
              "parts?make=Mazda&model=MX5&peryear=1998&variant=NB%2C+1.6+4cyl+ULP%2C+1.8+4+cyl+ULP%2C+18+4cyl+TULP",
            name: "1998-2005 NB",
          },
        ],
      },
      {
        title: "NC & ND",
        photo: photo13,
        links: [
          {
            link: "parts?make=Mazda&model=MX5&peryear=2005&variant=NC3",
            name: "2005-2015 NC",
          },
          {
            link:
              "parts?make=Mazda&model=MX5&peryear=2015&variant=ND%2C+1.5lt+4cyl+ULP",
            name: "2015-On ND 1.5",
          },
          {
            link:
              "parts?make=Mazda&model=MX5&peryear=2015&variant=ND%2C+2.0lt+4cyl+ULP",
            name: "2015-On ND 2.0",
          },
        ],
      },
    ],
  },
  {
    make: "Mitsubishi",
    model: "L200",
    links: [
      {
        title: "2WD",
        photo: photo14,
        links: [
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=1986&variant=2WD%2C+ME+-+MK+%28Coil+Frt%29",
            name: "1986-2006 ME-MK",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=1996&variant=2WD%2C+MK+%28T%2FBar+Frt%29",
            name: "1996-2006 MK",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=2006&variant=2WD%2C+ML+%28Coil+over+Frt%29",
            name: "2006-2009 ML",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=2008&variant=2WD%2C+MN",
            name: "2008-2015 MN",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=2015&variant=2WD%2C+MQ",
            name: "2015-on MQ",
          },
        ],
      },
      {
        title: "4WD",
        photo: photo15,
        links: [
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=1986&variant=4WD%2C+MH+%28T%2FBar+Frt%29",
            name: "1986-1991 MH",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=1991&variant=4WD%2C+MJ+%28T%2FBar+Frt%29",
            name: "1991-1996 MJ",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=1996&variant=4WD%2C+MK+%28T%2FBar+Frt%29",
            name: "1996-2006 MK",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=2006&variant=4WD%2C+ML+%28Coil+over+Frt%29",
            name: "2006-2009 ML",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=2009&variant=4WD%2C+MN",
            name: "2009-2015 MN",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=2015&variant=4WD%2C+MQ",
            name: "2015-2018 MQ",
          },
          {
            link:
              "parts?make=Mitsubishi&model=L200&peryear=2018&variant=4WD%2C+MR",
            name: "2018-on MR",
          },
        ],
      },
    ],
  },
  {
    make: "Mitsubishi",
    model: "Shogun & Pajero",
    links: [
      {
        title: "LWB",
        photo: photo16,
        links: [
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=2006&variant=NS%2C+NT+%26+NW%2C+LWB+5+door",
            name: "2006-2017 NS, NT & NW 5 Door",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=2000&variant=NM+%26+NP%2C+LWB+5+door",
            name: "2000-2006 NM & NP 5 Door",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=1991&variant=NH+to+NL+Coil+Rear%2C+LWB",
            name: "1991-2000 NH to NL Coil Rear 5 Door",
          },
        ],
      },
      {
        title: "SWB",
        photo: photo17,
        links: [
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=2006&variant=NS%2C+NT+%26+NW%2C+SWB+3+door",
            name: "2006-2017 NS, NT & NW 3 Door",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=2000&variant=NM+%26+NP%2C+SWB+3+door",
            name: "2000-2006 NM & NP 3 Door",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=1991&variant=NH+to+NL+Coil+Rear%2C+SWB",
            name: "1991-2000 NH to NL Coil Rear 3 Door",
          },
        ],
      },
      {
        title: "Other",
        photo: photo16,
        links: [
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=1991&variant=NH+%26+NJ+Leaf%2C+Leaf+Rear",
            name: "1991-1996 NH & NJ Leaf Rear",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=1988&variant=NF+%26+NG%2C+Leaf+Rear",
            name: "1988-1991 NF & NG Leaf Rear",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=1988&variant=NF+%26+NG%2C+Coil+Rear",
            name: "1988-1991 NF & NG Coil Rear",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=1984&variant=NB%2C+NC+%26+ND%2C+LWB+%26+SWB",
            name: "1984-1988 NB, NC & ND LWB & SWB",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+%2F+Pajero&peryear=1982&variant=NA%2C+LWB+%26+SWB",
            name: "1982-1984 NA LWB & SWB",
          },
        ],
      },
    ],
  },
  {
    make: "Mitsubishi",
    model: "Shogun Sport",
    links: [
      {
        title: "",
        photo: photo18,
        links: [
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+Sport&peryear=2009&variant=PB",
            name: "Mitsubishi Shogun Sport PB 2009-2013",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+Sport&peryear=2000&variant=",
            name: "Mitsubishi Shogun Sport PA 2000-2006",
          },
          {
            link:
              "parts?make=Mitsubishi&model=Shogun+Sport&peryear=1996&variant=PA+Leaf+Spring+Rear",
            name: "Mitsubishi Shogun Sport PA 1996-2000",
          },
        ],
      },
    ],
  },
  {
    make: "Nissan",
    model: "Navara",
    links: [
      {
        title: "2WD",
        photo: photo19,
        links: [
          {
            link:
              "parts?make=Nissan&model=Navara&peryear=1985&variant=D21+%26+D22+%2C+2WD",
            name: "D21 & D22 1985-2015",
          },
          {
            link:
              "parts?make=Nissan&model=Navara&peryear=2015&variant=D40+%2C+2WD+%26+4WD+Leaf+Over+Axle",
            name: "D40 2005-2015",
          },
        ],
      },
      {
        title: "4WD",
        photo: photo20,
        links: [
          {
            link:
              "parts?make=Nissan&model=Navara&peryear=1985&variant=D21+%26+D22+%2C+4WD",
            name: "D21 & D22 1985-2015",
          },
          {
            link:
              "parts?make=Nissan&model=Navara&peryear=2015&variant=D23+%2C+NP300+4WD+Coil+Spring+Rear",
            name: "D23 2015-on Coil Spring Rear",
          },
          {
            link:
              "parts?make=Nissan&model=Navara&peryear=2015&variant=D23+%2C+NP300+4WD+Leaf+Spring+Rear",
            name: "D23 2015-on Leaf Spring Rear",
          },
          {
            link:
              "parts?make=Nissan&model=Navara&peryear=2005&variant=D40+%2C+2WD+%26+4WD+Leaf+Over+Axle",
            name: "D40 2005-2015",
          },
          {
            link:
              "parts?make=Nissan&model=Navara&peryear=2005&variant=D40+%2C+4WD+Leaf+Over+Axle+550",
            name: "D40 2005-2015 550 V6 Diesel",
          },
        ],
      },
    ],
  },
  {
    make: "Nissan",
    model: "Pathfinder",
    links: [
      {
        title: "",
        photo: photo21,
        links: [
          {
            link: "parts?make=Nissan&model=Pathfinder&peryear=2019&variant=R52",
            name: "Nissan Pathfinder R52",
          },
          {
            link: "parts?make=Nissan&model=Pathfinder&peryear=2008&variant=R51",
            name: "Nissan Pathfinder R51",
          },
          {
            link: "parts?make=Nissan&model=Pathfinder&peryear=2001&variant=R50",
            name: "Nissan Pathfinder R50",
          },
          {
            link:
              "parts?make=Nissan&model=Pathfinder&peryear=1992&variant=WD21",
            name: "Nissan Pathfinder WD21",
          },
        ],
      },
    ],
  },
  {
    make: "Nissan",
    model: "Patrol",
    links: [
      {
        title: "Nissan Patrol",
        photo: photo22,
        links: [
          {
            link: "parts?make=Nissan&model=Patrol&peryear=1961&variant=G60",
            name: "1961-1980 G60",
          },
          {
            link: "parts?make=Nissan&model=Patrol&peryear=1980&variant=MQ",
            name: "1980-1983 MQ",
          },
          {
            link: "parts?make=Nissan&model=Patrol&peryear=1983&variant=MK",
            name: "1983-1988 MK",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=1988&variant=GQ+%26+GQII+%28Y60%29%2C+3+Door+Wagon",
            name: "1988-97 GQ & GQII (Y60) 3 Door Wagon",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=1988&variant=GQ+%26+GQII+%28Y60%29%2C+5+Door+Wagon",
            name: "1988-97 GQ & GQII (Y60) 5 Door Wagon",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=1988&variant=GQ+%26+GQII+%28Y60%29%2C+Cab+Chassis+%28rear+coil+springs%29",
            name: "1988-97 GQ & GQII (Y60) Cab Chassis (rear coil springs)",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=1988&variant=GQ+%26+GQII+%28Y60%29%2C+Cab+Chassis+%28rear+leaf+springs%29",
            name: "1988-97 GQ & GQII (Y60) Cab Chassis (rear leaf springs)",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=1997&variant=GU+%28Y61%29%2C+5+Door+Wagon",
            name: "1997-2001 GU (Y61) 5 Door Wagon",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=1997&variant=GU+%28Y61%29%2C+Cab+Chassis+%28rear+coil+springs%29",
            name: "1997-2001 GU (Y61) Cab Chassis (rear coil springs)",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=1997&variant=GU+%28Y61%29%2C+Cab+Chassis+%28rear+leaf+springs%29",
            name: "1997-2001 GU (Y61) Cab Chassis (rear leaf springs)",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=2002&variant=GUII+%28Y61%29%2C+5+Door+Wagon",
            name: "2002-2016 GUII (Y61) 5 Door Wagon",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=2002&variant=GUII+%28Y61%29%2C+Cab+Chassis+%28rear+coil+springs%29",
            name: "2002-2016 GUII (Y61) Cab Chassis (rear coil springs)",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=2002&variant=GUII+%28Y61%29%2C+Cab+Chassis+%28rear+leaf+springs%29",
            name: "2002-2016 GUII (Y61) Cab Chassis (rear leaf springs)",
          },
          {
            link:
              "parts?make=Nissan&model=Patrol&peryear=2010&variant=Y62+Wagon+%28UAE+Market%29%2C+5.6lt+8cyl+ULP",
            name: "2010-On Y62 Wagon (UAE Market) 5.6lt 8cyl ULP",
          },
        ],
      },
    ],
  },
  {
    make: "Nissan",
    model: "X-Trail",
    links: [
      {
        title: "T30",
        photo: photo23,
        links: [
          {
            link:
              "parts?make=Nissan&model=X-Trail&peryear=2001&variant=T30+%2C+2.2lt+4cyl+TD",
            name: "2001-2009 2.2lt 4cyl TD",
          },
          {
            link:
              "parts?make=Nissan&model=X-Trail&peryear=2001&variant=T30+%2C+2.5lt+4cyl+ULP",
            name: "2001-2009 2.5lt 4cyl ULP",
          },
        ],
      },
      {
        title: "T31",
        photo: photo24,
        links: [
          {
            link: "parts?make=Nissan&model=X-Trail&peryear=2007&variant=T31",
            name: "2007-2014",
          },
        ],
      },
      {
        title: "T32",
        photo: photo25,
        links: [
          {
            link:
              "parts?make=Nissan&model=X-Trail&peryear=2014&variant=T32+Series+1+AWD%2C+1.6+D+4cyl",
            name: "2014-2016 Series I AWD",
          },
          {
            link:
              "parts?make=Nissan&model=X-Trail&peryear=2014&variant=T32+Series+1+FWD%2C+1.6+D+4cyl",
            name: "2014-2016 Series I FWD",
          },
          {
            link:
              "parts?make=Nissan&model=X-Trail&peryear=2016&variant=T32+Series+II+AWD%2C+1.6+D+4cyl",
            name: "2016-On Series II AWD",
          },
          {
            link:
              "parts?make=Nissan&model=X-Trail&peryear=2016&variant=T32+Series+II+FWD%2C+1.6+D+4cyl",
            name: "2016-On Series II FWD",
          },
        ],
      },
    ],
  },
  {
    make: "Subaru",
    model: "Forester",
    links: [
      {
        title: "1997-2008",
        photo: photo26,
        links: [
          {
            link:
              "parts?make=Subaru&model=Forester&peryear=1997&variant=SF+Model",
            name: "Product available for Subaru Forester 1997-2002 SF Model",
          },
          {
            link:
              "parts?make=Subaru&model=Forester&peryear=2002&variant=SG+Model",
            name: "Product available for Subaru Forester 2002-2008 SG Model",
          },
        ],
      },
      {
        title: "2008-On",
        photo: photo27,
        links: [
          {
            link:
              "parts?make=Subaru&model=Forester&peryear=2008&variant=SH+Model",
            name: "Product available for Subaru Forester 2008-2013 SH Model",
          },
          {
            link:
              "parts?make=Subaru&model=Forester&peryear=2014&variant=SJ+Model",
            name: "Product available for Subaru Forester 2013- SJ Model",
          },
        ],
      },
    ],
  },
  {
    make: "Subaru",
    model: "Impreza",
    links: [
      {
        title: "Classic",
        photo: photo28,
        links: [
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=1992&variant=GC%2C+Sedan",
            name: "1992-2000 GC Sedan",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=1992&variant=GF%2C+Wagon",
            name: "1992-2000 GF Wagon",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=1994&variant=GC+WRX%2C+Sedan",
            name: "1994-2000 GC WRX Sedan",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=1994&variant=GF+WRX%2C+Wagon",
            name: "1994-2000 GF WRX Wagon",
          },
        ],
      },
      {
        title: "Bug Eye",
        photo: photo29,
        links: [
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2000&variant=GD%2C+Sedan",
            name: "2000-2002 GD Sedan",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2000&variant=GD+WRX%2C+Sedan",
            name: "2000-2002 GD WRX Sedan",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2000&variant=GD+WRX+STi%2C+Sedan",
            name: "2000-2002 GD WRX STi Sedan",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2000&variant=GG%2C+Wagon",
            name: "2000-2002 GG Wagon",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2000&variant=GG+WRX%2C+Wagon",
            name: "2000-2002 GG WRX Wagon",
          },
        ],
      },
      {
        title: "Blob Eye/ Hawk Eye",
        photo: photo30,
        links: [
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2002&variant=GD+%2C+Sedan",
            name: "2002-2007 GD Sedan",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2002&variant=GD+WRX%2C+Sedan",
            name: "2002-2007 GD WRX Sedan",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2002&variant=GG%2C+Wagon",
            name: "2002-2007 GG Wagon",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2002&variant=GG+WRX%2C+Wagon",
            name: "2002-2007 GG WRX Wagon",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2002&variant=GD+WRX+STi%2C+Sedan",
            name: "2005-2007 GD WRX STi Sedan",
          },
        ],
      },
      {
        title: "Shark Eye",
        photo: photo31,
        links: [
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2007&variant=GE+%26+GH",
            name: "2007-2011 GE/GH",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2007&variant=GE+%26+GH+WRX+%26+STi",
            name: "2007-2011 GE/GH WRX & STI",
          },
        ],
      },
      {
        title: "GV Sedan",
        photo: photo32,
        links: [
          {
            link: "parts?make=Subaru&model=Impreza&peryear=2011&variant=GV+WRX",
            name: "2011-2013 GV WRX",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2011&variant=GV+WRX+Sti%2C+Sedan",
            name: "2011-2014 GV WRX STi Sedan",
          },
        ],
      },
      {
        title: "GJ Sedan",
        photo: photo33,
        links: [
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2011&variant=GJ+%26+GP",
            name: "2011-2014 GJ/GP",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2011&variant=GJ+%26+GP+WRX",
            name: "2011-2014 GJ/GP WRX",
          },
          {
            link:
              "parts?make=Subaru&model=Impreza&peryear=2011&variant=GJ+%26+GP+WRX+STi",
            name: "2011-2014 GJ/GP WRX STi",
          },
        ],
      },
    ],
  },
  {
    make: "Subaru",
    model: "BRZ",
    links: [
      {
        title: "Subaru BRZ parts catalogue",
        photo: photo34,
        links: [
          {
            link: "parts?make=Subaru&model=BRZ&peryear=2012&variant=",
            name: "Products available for Subaru BRZ 2.0L 2012-Onwards",
          },
        ],
      },
    ],
  },
  {
    make: "Toyota",
    model: "Hilux 4WD",
    links: [
      {
        title: "1979-2001",
        photo: photo35,
        links: [
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=1979&variant=MK1+LN36-46+%26+RN36-46",
            name: "1979-1983 MK1 LN36-46&RN36-46",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=1983&variant=MK2+YN60-67+%26+LN60-67%2C+Leaf+Sprung",
            name: "1983-1988 MK2 YN60-67 & LN60-67",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=1988&variant=IMPORT+LN%2FYN107-111%2C+RN106-110%2C+.IFS+Front%2C+Leaf+Rear",
            name: "1988-1997 IMPORT LN/YN/RN",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=1988&variant=MK3+LN105R%2C+YN106R%2C+Leaf+Front+%26+Rear",
            name: "1988-1997 MK3 LN105R, YN106R",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=1997&variant=MK4+LN165R%2C+Torsion+bar+front%2C+leaf+rear",
            name: "1997-2001 MK4 LN165R",
          },
        ],
      },
      {
        title: "2001-2015",
        photo: photo36,
        links: [
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=2001&variant=MK5+KDN165R%2C+KDN165R",
            name: "2001-2005 MK5 KDN165R",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=2005&variant=MK6+GGN25%2C+KUN25R%2C+KUN26R%2C+GGN25%2C+KUN25R%2C+KUN26R",
            name: "2005-2010 MK6 GGN25, KUN25R/26R",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=2010&variant=MK7+GGN25%2C+KUN25R%2C+KUN26R%2C+GGN25%2C+KUN25R+KUN26R",
            name: "2010-2015 MK7 GGN25, KUN25R/26R",
          },
        ],
      },
      {
        title: "2015-on",
        photo: photo37,
        links: [
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=2015&variant=MK8+GUN125R%2C+Double+Cab+Tub+Body",
            name: "2015-Onward GUN125R Double Cab",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=2015&variant=MK8+GUN125R%2C+Extra+Cab+Cab-Chassis",
            name: "2015-Onward GUN125R Extra Cab",
          },
          {
            link:
              "parts?make=Toyota&model=Hilux+4WD&peryear=2015&variant=MK8+GUN125R%2C+Single+Cab+Cab-Chassis",
            name: "2015-Onward GUN125R Single Cab",
          },
        ],
      },
    ],
  },
  {
    make: "Toyota",
    model: "Landcruiser",
    links: [
      {
        title: "200 Series",
        photo: photo38,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2007&variant=200+Series%2C+UZJ200R+With+KDSS",
            name: "2007-2012 UZJ200R With KDSS",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2007&variant=200+Series%2C+UZJ200R+Without+KDSS",
            name: "2007-2012 UZJ200R Without KDSS",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2007&variant=200+Series%2C+VDJ200R+With+KDSS",
            name: "2007-On VDJ200R With KDSS",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2007&variant=200+Series%2C+VDJ200R+Without+KDSS",
            name: "2007-On VDJ200R Without KDSS",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2012&variant=200+Series%2C+URJ202R+With+KDSS",
            name: "2012-On URJ202R With KDSS",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2012&variant=200+Series%2C+URJ202R+Without+KDSS",
            name: "2012-On URJ202R Without KDSS",
          },
        ],
      },
      {
        title: "150 Series",
        photo: photo39,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2009&variant=150+series%2C+KDJ155R",
            name: "2009-2013 KDJ155R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2009&variant=150+series%2C+KDJ150R",
            name: "2009-2015 KDJ150R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2009&variant=150+series%2C+GRJ150R",
            name: "2009-2017 GRJ150R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2015&variant=150+series%2C+GDJ150R",
            name: "2015-On GDJ150R",
          },
        ],
      },
      {
        title: "120 Series",
        photo: photo40,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2002&variant=120+series%2C+LC3+LC5%2C+KDJ120%2C+KZJ120%2C+RZJ120+%26+GRJ12",
            name: "2002-2009 LC3, LC5",
          },
        ],
      },
      {
        title: "100 Series",
        photo: photo41,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1998&variant=100+Series%2C+HD%2C+FZJ+%26+UZJ100+IFS",
            name: "1998-2007 HD, FZJ & UZJ100 IFS",
          },
        ],
      },
      {
        title: "90 Series",
        photo: photo42,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1996&variant=90+series%2C+LWB%2C+KZJ95%2C+RZJ95+%26+VZJ95",
            name: "1996-2002 LWB",
          },
        ],
      },
      {
        title: "80 Series",
        photo: photo43,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1990&variant=80+Series%2C+FJ80+%26+HDJ80",
            name: "1990-1992 FJ80 & HDJ80",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1992&variant=80+Series%2C+FZJ80%2C+HDJ80+%26+HZJ80",
            name: "1992-1998 FZJ80, HDJ80 & HZJ80",
          },
        ],
      },
      {
        title: "70 Series",
        photo: photo44,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1984&variant=70+Series%2C+BJ%2FFJ+70+%26+73+Series",
            name: "1984-1987 BF, FJ 70 & 73",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1984&variant=70+Series%2C+75+Series",
            name: "1984-2001 75",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1990&variant=70+Series%2C+LJ79",
            name: "1990-1995 LJ79",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1999&variant=70+Series%2C+FZJ78R",
            name: "1999-2007 FZJ78R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1999&variant=70+Series%2C+FZJ79R",
            name: "1999-2007 FZJ79R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1999&variant=70+Series%2C+HDJ78R",
            name: "1999-2007 HDJ78R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1999&variant=70+Series%2C+HDJ79R",
            name: "1999-2007 HDJ79R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1999&variant=70+Series%2C+HZJ78R",
            name: "1999-2007 HZJ78R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1999&variant=70+Series%2C+HZJ79R",
            name: "1999-2007 HZJ79R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2007&variant=70+Series%2C+VDJ76R",
            name: "2007-2016 VDJ76R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2007&variant=70+Series%2C+VDJ78R",
            name: "2007-On VDJ78R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2007&variant=70+Series%2C+VDJ79R",
            name: "2007-On VDJ79R",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=2016&variant=70+Series%2C+VDJ76R",
            name: "2016-On VDJ76R",
          },
        ],
      },
      {
        title: "60 Series",
        photo: photo45,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1980&variant=60+Series%2C+FJ60%2C+FJ62+HJ60",
            name: "1980-1985 FJ60, FJ62 & HJ60",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1985&variant=60+Series%2C+FJ60%2C+61+%26+HJ60%2C+61",
            name: "1985-1991 FJ60, 61 & HJ60, 61",
          },
        ],
      },
      {
        title: "50 Series",
        photo: photo46,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1969&variant=50+Series%2C+FJ55%2C+FJ56",
            name: "1969-1980 FJ55 & FJ56",
          },
        ],
      },
      {
        title: "40 Series",
        photo: photo47,
        links: [
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1959&variant=40+Series%2C+BJ%2C+FJ+%26+HJ40",
            name: "1959-1980 BJ, FJ & HJ40",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1965&variant=40+Series%2C+BJ%2C+FJ+%26+HJ43",
            name: "1965-1984 BJ, FJ & HJ43",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1969&variant=40+Series%2C+BJ%2C+FJ+%26+HJ45",
            name: "1969-1980 BJ, FJ & HJ45",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1980&variant=40+Series%2C+FJ%2C+HJ40+%26+42",
            name: "1980-1985 FJ, HJ40 & 42",
          },
          {
            link:
              "parts?make=Toyota&model=Landcruiser&peryear=1980&variant=40+Series%2C+FJ%2C+HJ45+%26+HJ47",
            name: "1980-1985 FJ, HJ45 & HJ47",
          },
        ],
      },
    ],
  },
  {
    make: "Vauxhall",
    model: "Monaro & VXR8",
    links: [
      {
        title: "2004-2006",
        photo: "",
        links: [
          {
            link: "parts?make=Vauxhall&model=Monaro&peryear=2004&variant=CV8",
            name: "2004 Monaro CV8 5.7",
          },
          {
            link: "parts?make=Vauxhall&model=Monaro&peryear=2004&variant=VXR",
            name: "2004 Monaro VXR 5.7",
          },
          {
            link: "parts?make=Vauxhall&model=Monaro&peryear=2005&variant=VXR",
            name: "2005-2006 Monaro VXR 6.0",
          },
          {
            link: "parts?make=Vauxhall&model=Monaro&peryear=2005&variant=CV8",
            name: "2005-2006 Monaro CV8 5.7",
          },
        ],
      },
      {
        title: "2006-Onwards",
        photo: "",
        links: [
          {
            link:
              "parts?make=Vauxhall&model=VXR8&peryear=2006&variant=VE%2C+Clubsport+R8",
            name: "2006-2013 VXR8 VE Clubsport",
          },
          {
            link:
              "parts?make=Vauxhall&model=VXR8&peryear=2013&variant=VF%2C+Clubsport+R8",
            name: "2013-on VXR8 VF Clubsport",
          },
          {
            link:
              "parts?make=Vauxhall&model=VXR8&peryear=2013&variant=VF%2C+Clubsport+R8+Tourer",
            name: "2013-on VXR8 VF Clubsport Tourer",
          },
          {
            link:
              "parts?make=Vauxhall&model=VXR8&peryear=2013&variant=VF%2C+Maloo",
            name: "2013-on VXR8 VF Maloo",
          },
        ],
      },
    ],
  },
  {
    make: "Volkswagen",
    model: "Amarok",
    links: [
      {
        title: "Amarok",
        photo: photo48,
        links: [
          {
            link:
              "parts?make=Volkswagen&model=Amarok&peryear=2012&variant=2H%2C+2.0lt+4cy+TTD",
            name: "2H 2.0lt 4cyl TTD",
          },
          {
            link:
              "parts?make=Volkswagen&model=Amarok&peryear=2012&variant=2H%2C+2.0lt+4cyl+TD",
            name: "2H 2.0lt 4cyl TD",
          },
          {
            link:
              "parts?make=Volkswagen&model=Amarok&peryear=2012&variant=2H%2C+3.0lt+6cyl+TD",
            name: "2H 3.0lt 6cyl TD",
          },
        ],
      },
    ],
  },
  {
    make: "Volkswagen",
    model: "Transporter",
    links: [
      {
        title: "1953-1990",
        photo: photo49,
        links: [
          {
            link:
              "parts?make=Volkswagen&model=Transporter&peryear=1953&variant=All",
            name: "1953-1967",
          },
          {
            link:
              "parts?make=Volkswagen&model=Transporter&peryear=1990&variant=T4",
            name: "1990-2003, T4",
          },
        ],
      },
      {
        title: "1991-2010",
        photo: photo50,
        links: [
          {
            link:
              "parts?make=Volkswagen&model=Transporter&peryear=2010&variant=T5%2C+4+Motion+%2F+4WD",
            name: "2003-7/2015 T5 4 Motion / 4WD",
          },
          {
            link:
              "parts?make=Volkswagen&model=Transporter&peryear=2010&variant=T5%2C+FWD",
            name: "2003-7/2015 T5 FWD",
          },
        ],
      },
      {
        title: "2011-On",
        photo: photo51,
        links: [
          {
            link:
              "parts?make=Volkswagen&model=Transporter&peryear=2015&variant=T6%2C+4+Motion+%2F+4WD",
            name: "2015-Onwards T6 4 Motion / 4WD",
          },
          {
            link:
              "parts?make=Volkswagen&model=Transporter&peryear=2015&variant=T6%2C+FWD",
            name: "2015-Onwards T6 FWD",
          },
        ],
      },
    ],
  },
  {
    make: "Volkswagen",
    model: "Golf",
    links: [
      {
        title: "1974-2005",
        photo: photo52,
        links: [
          {
            link: "parts?make=Volkswagen&model=Golf&peryear=1974&variant=All",
            name: "1974-1983 MK1 17 Series Hatchback",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=1979&variant=MK1%2C+155+Series%2C+Cabriolet+Only",
            name: "1979-1989 155 Series Cabriolet Only",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=1983&variant=MK2%2C+19E+%26+1G1",
            name: "1983-1991 MK2 19E & 1G1",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=1983&variant=MK2%2C+19E+%26+1G1",
            name: "1991-1997 MK3 1H Hatchback",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=1993&variant=MK3%2C+1E+Cabriolet%2C+Excludes+VR6",
            name: "1993-1998 MK3 1E Cabriolet Excludes VR6",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=1993&variant=MK3%2C+1H+Wagon",
            name: "1993-1999 MK3 1H Wagon",
          },
          {
            link:
              "/parts?make=Volkswagen&model=Golf&peryear=1997&variant=MK4%2C+1J+Hatchback%2C+Excludes+Cabriolet",
            name: "1997-2005 MK4 1J Hatchback Excludes Cabriolet",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=1998&variant=MK4%2C+1E+Cabriolet",
            name: "1998-2005 MK4 1E Carbiolet",
          },
        ],
      },
      {
        title: "2003-on",
        photo: photo53,
        links: [
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=2003&variant=MK5%2C1K",
            name: "2003-2009 MK5 1K",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=2006&variant=MK5%2C+R32+1K",
            name: "2006-2009 MK5 R32 1K",
          },
          {
            link:
              "parts?make=Volkswagen&model=Golf&peryear=2009&variant=MK6+5K",
            name: "2009-2013 MK6 5K",
          },
          {
            link: "parts?make=Volkswagen&model=Golf&peryear=2012&variant=MK7",
            name: "2012-on MK7",
          },
        ],
      },
    ],
  },
];
